import { useEffect } from 'react';

import { useNavigate } from 'react-router';

import { useAuth } from '@clerk/clerk-react';

interface LoggedOutRouteProps {
  children: React.ReactNode;
}

export default function LoggedOutRoute({ children }: LoggedOutRouteProps) {
  const { isSignedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSignedIn) {
      navigate('/home', { replace: true });
    }
  }, [isSignedIn, navigate]);

  if (isSignedIn) {
    return null;
  }

  return <>{children}</>;
}
